export default "__VITE_ASSET__BxlvKPQt__"